var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"root",staticClass:"er"},[_vm._v(_vm._s(_vm.$get(_vm.user, "name")))])}
var staticRenderFns = []

export { render, staticRenderFns }